import type { Result } from 'ahooks/lib/useRequest/src/types';
import type { BaseModel, IExtra } from './createRequest';
import { RemoveAnd } from '@/kus/flat';
export type IFetch<Model extends BaseModel> = {
    [K in keyof Model]: (
        payload?: RemoveAnd<{ body?: Model[K]['requestBody'] } & Model[K]['parameters']> | null,
        config?: {
            extra?: IExtra;
        },
    ) => Result<Model[K]['responses'], RemoveAnd<{ body?: Model[K]['requestBody'] } & Model[K]['parameters']>[]>;
};

const fetchMap = {};
export function createUseRequestMap<IModels extends BaseModel>(useHttp: any) {
    return new Proxy(fetchMap, {
        get(target, prop) {
            return (...args: any) => useHttp(prop, ...args);
        },
    }) as IFetch<IModels>;
}
